export interface IAspectType {
     All: boolean,
     WorkUp: boolean,
     PreOp: boolean,
     SurgeryPlusThree: boolean,
     SurgeryPlusThirty: boolean
}